import React, { useEffect, useState } from 'react';
import { Card, Row, Col, Statistic, Timeline, List, Typography, Spin } from 'antd';
import { ProjectOutlined, ClockCircleOutlined } from '@ant-design/icons';
import axios from 'axios';

const { Title } = Typography;

const Overview = () => {
  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState({});
  const [recentActivity, setRecentActivity] = useState([]);
  const [myTasks, setMyTasks] = useState([]);

  useEffect(() => {
    fetchDashboardData();
  }, []);

  const fetchDashboardData = async () => {
    try {
      setLoading(true);
      // Fetch dashboard stats
      const statsResponse = await axios.get('/project_board/dashboard/stats/');
      setStats(statsResponse.data);

      // Fetch recent activity
      const activityResponse = await axios.get('/project_board/dashboard/recent_activity/');
      setRecentActivity(activityResponse.data);

      // Fetch my tasks
      const tasksResponse = await axios.get('/project_board/dashboard/my_tasks/');
      setMyTasks(tasksResponse.data);
    } catch (error) {
      console.error('Error fetching dashboard data:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div style={{ textAlign: 'center', padding: '50px' }}><Spin size="large" /></div>;
  }

  return (
    <div style={{ padding: '24px' }}>
      <Title level={2}>Project Board Overview</Title>

      {/* Statistics Cards */}
      <Row gutter={16} style={{ marginBottom: '24px' }}>
        <Col span={6}>
          <Card>
            <Statistic
              title="Total Projects"
              value={stats.total_projects || 0}
              prefix={<ProjectOutlined />}
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic
              title="Active Projects"
              value={stats.active_projects || 0}
              valueStyle={{ color: '#3f8600' }}
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic
              title="Total Tasks"
              value={stats.total_tasks || 0}
              prefix={<ClockCircleOutlined />}
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic
              title="My Tasks"
              value={stats.my_tasks || 0}
              valueStyle={{ color: '#1890ff' }}
            />
          </Card>
        </Col>
      </Row>

      {/* Main Content */}
      <Row gutter={16}>
        {/* My Tasks Summary */}
        <Col span={12}>
          <Card title="My Assigned Tasks" style={{ marginBottom: '16px' }}>
            <List
              dataSource={myTasks}
              renderItem={item => (
                <List.Item>
                  <List.Item.Meta
                    title={item.title}
                    description={`Project: ${item.project_name} | Due: ${item.due_date || 'No due date'}`}
                  />
                </List.Item>
              )}
            />
          </Card>
        </Col>

        {/* Recent Activity Feed */}
        <Col span={12}>
          <Card title="Recent Activity">
            <Timeline>
              {recentActivity.map((activity, index) => (
                <Timeline.Item key={index}>
                  <p>{activity.text}</p>
                  <small>{activity.user_name} - {new Date(activity.created_at).toLocaleString()}</small>
                </Timeline.Item>
              ))}
            </Timeline>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default Overview;
